import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
export interface DownloadListInput {
  userName: string;
  downloadTime: Date;
}
export interface DownloadList{
  userName: string;
  ipAddress: string;
  downloadTime: string;
  productName: string;
  country: string;
  title: string;
  date:string;
  version:string;
}
@Injectable({
  providedIn: 'root'
})
export class DownloadActivityService {

  apiUrl = environment.apiURL;

  constructor(private http: HttpClient,private spinner:NgxSpinnerService) { }
  getDownloadActivityResult(post: DownloadListInput): Observable<DownloadList> {
    this.spinner.show();
    return this.http.post<DownloadList>(
      `${this.apiUrl}/rest/admin/download/report`,
      post
    );
  }}
